import { DocumentService, GoogleDriveAdapter } from '@xq/infrastructure';

export class DeleteFileFromDriveUseCase {
  static async execute(fileId: string): Promise<boolean> {
    return DocumentService.getInstance(
      GoogleDriveAdapter.getInstance()
    ).deleteDocumentFromStorage(fileId);
  }
}
